import { useState, useEffect } from "react";
import { Search, MessageSquare, Calendar, Users, FileText, Lock } from "lucide-react";
import ImageLightbox from "./ImageLightbox";
import { useLanguage } from "../context/LanguageContext";

const HINTS = {
  fr: { zoom: "cliquer pour agrandir", tour: "cliquer pour la visite guidée", soon: "Écran montré en démo privée", search: "Rechercher" },
  en: { zoom: "click to enlarge", tour: "click for the guided tour", soon: "Screen shown in a private demo", search: "Search" },
  es: { zoom: "clic para ampliar", tour: "clic para la visita guiada", soon: "Pantalla mostrada en demo privada", search: "Buscar" },
};

export const TeamsFrame = ({ src, alt, caption, placeholder, slides, slideIndex = 0 }) => {
  const { language } = useLanguage();
  const hint = HINTS[language] || HINTS.fr;
  const [err, setErr] = useState(false);
  useEffect(() => setErr(false), [src]);
  return (
  <figure className="w-full" data-testid="teams-frame">
    <div className="rounded-[10px] border border-linec-300 bg-white overflow-hidden shadow-[0_28px_60px_-20px_rgba(10,35,66,0.35),0_2px_6px_-2px_rgba(10,35,66,0.12)] ring-1 ring-navy-900/[0.04]">
      {/* Title bar with fake search */}
      <div className="h-9 bg-[#F7F9FC] border-b border-[#C3CFE0] flex items-center justify-center px-3">
        <div className="flex items-center gap-1.5 bg-white border border-[#C3CFE0] rounded-md px-3 py-1 w-1/2 max-w-[280px]">
          <Search className="w-3 h-3 text-[#9098A3]" />
          <span className="text-[10px] text-[#9098A3]">{hint.search}</span>
        </div>
      </div>
      <div className="flex">
        {/* Left rail */}
        <div className="w-[56px] bg-[#EBEBEF] flex flex-col items-center py-3 gap-3 flex-shrink-0">
          <span className="w-8 h-8 rounded-lg bg-[#0047AB] flex items-center justify-center text-white text-xs font-bold font-display">C</span>
          {[MessageSquare, Calendar, Users, FileText].map((Icon, i) => (
            <span key={i} className="w-8 h-8 rounded-lg flex items-center justify-center text-[#9098A3]">
              <Icon className="w-4 h-4" />
            </span>
          ))}
        </div>
        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="border-b border-[#C3CFE0] px-4 flex items-center gap-4 h-8">
            <span className="text-[11px] font-semibold text-[#0A2342] border-b-2 border-[#0047AB] h-full flex items-center">Cayus</span>
            <span className="text-[11px] text-[#9098A3]">Publications</span>
          </div>
          {src && !err ? (
            <ImageLightbox src={src} alt={alt} slides={slides} startIndex={slideIndex}>
              <img src={src} alt={alt} className="w-full h-auto block" onError={() => setErr(true)} />
            </ImageLightbox>
          ) : (
            <div className="aspect-[16/9] bg-[#0A2342] flex flex-col items-center justify-center gap-2.5 px-8 text-center">
              <Lock className="w-5 h-5 text-[#9ECEFA]" />
              <p className="mono-cayus text-[11px] text-[#CFE6FC]">{placeholder || hint.soon}</p>
              {alt && <p className="font-body-cayus text-xs text-[#9098A3] max-w-[280px] leading-relaxed">{alt}</p>}
            </div>
          )}
        </div>
      </div>
    </div>
    {caption && (
      <figcaption className="mono-cayus text-[#5E6C83] mt-3 break-words">
        {caption}
        {src && !err && <span className="text-[#9098A3]"> · {slides && slides.length > 1 ? hint.tour : hint.zoom}</span>}
      </figcaption>
    )}
  </figure>
  );
};

export default TeamsFrame;
